import { render, staticRenderFns } from "./secondfourth.vue?vue&type=template&id=f8329c04&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8329c04')) {
      api.createRecord('f8329c04', component.options)
    } else {
      api.reload('f8329c04', component.options)
    }
    module.hot.accept("./secondfourth.vue?vue&type=template&id=f8329c04&", function () {
      api.rerender('f8329c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/second/secondfourth.vue"
export default component.exports